import { queryKeys } from '@/lib/queryKeys'

export function invalidateFaqs(qc, workspaceId, botId) {
  return qc.invalidateQueries({ queryKey: queryKeys.chatbotFaqs(workspaceId, botId) })
}

export function invalidateSources(qc, workspaceId, botId) {
  return qc.invalidateQueries({ queryKey: queryKeys.chatbotSources(workspaceId, botId) })
}

export function invalidateConversations(qc, workspaceId, botId) {
  return qc.invalidateQueries({
    queryKey: [...queryKeys.chatbotBot(workspaceId, botId), 'conversations'],
  })
}
